import React from "react";
import "./final-onboarding-screen.scss";
import { observer } from "mobx-react";
import useDashboardTranslation from "../../../../dashboard-translation/hooks/dashboard-translation-hook";
import adjustYourPolicies from "../../../../images/onboarding/adjust-your-policies.svg";
import testYourPortal from "../../../../images/onboarding/test-your-portal.svg";
import publishYourPortal from "../../../../images/onboarding/publish-your-portal.svg";
import FinalOnboardingScreenStep from "./final-onboarding-screen-step/final-onboarding-screen-step";
import { IStepComponent } from "../../onboarding-page";
import FinalScreenStore from "../../stores/final-screen-store";
import OnBoardingScreenTitle from "../onboarding-screen-title/onboarding-screen-title";
import OnBoardingButton from "../onboarding-button/onboarding-button";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import AHref from "../../../../components/ahref/ahref";
import { CANDU_EVENTS } from "../../../../services/candu-service";
import rmsCanduStore from "../../../../stores/rms-candu-store";
import { PROFILE_CAPABILITIES } from "../../../../models/ProfileCapabilities";
import ResolveCapability from "../../../../components/resolve-capability/resolve-capability";
import {BUTTON_VARIANTS} from "../../../../components/inputs/button-variants";
import {Button} from "../../../../components/inputs/button/button";

export interface INextStep {
    imgSrc: string;
    alt: string;
    title: string;
    description: string;
}

const FinalOnboardingScreen:React.FC<IStepComponent> = observer((props) => {
    const store = props.store as FinalScreenStore;
    
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-onboarding";

    const nextSteps:INextStep[] = [
        {
            imgSrc: adjustYourPolicies,
            alt: "adjust your policies",
            title: getTranslation("ADJUST_POLICIES_TITLE", scope),
            description: getTranslation("ADJUST_POLICIES_SUBTITLE", scope),
        },
        {
            imgSrc: testYourPortal,
            alt: "test your portal",
            title: getTranslation("TEST_YOUR_PORTAL_TITLE", scope),
            description: getTranslation("TEST_YOUR_PORTAL_SUBTITLE", scope),
        },
        {
            imgSrc: publishYourPortal,
            alt: "publish your portal",
            title: getTranslation("PUBLISH_YOUR_PORTAL_TITLE", scope),
            description: getTranslation("PUBLISH_YOUR_PORTAL_SUBTITLE", scope),
        },
    ];

    const handleCompleteOnboarding = () => {
        store.completeOnboarding();
        rmsCanduStore.trackEvent(CANDU_EVENTS.ONBOARDING_COMPLETED);
    }

    return(
        <div className="final-onboarding-screen">
            <div className="final-onboarding-screen-title-container">
                <OnBoardingScreenTitle
                    titleText={getTranslation("WHATS_NEXT", scope)}
                />
            </div>
            <div className="final-onboarding-screen-steps">
                { nextSteps.map((step, index) => {
                    return (
                        <FinalOnboardingScreenStep step={step} key={index} />
                    )
                })}
            </div>

            <div className="onboarding-wizard-final-screen-footer">
                <OnBoardingButton
                    onClick={handleCompleteOnboarding}
                    isLoading={store.isLoading}
                    buttonText={getTranslation("GET_STARTED_NOW",scope)}
                    paddingBottom={12}
                />
	            <ResolveCapability capability={PROFILE_CAPABILITIES.SUPPORT}>
		            {({ allowOnboardingCallBooking }) => allowOnboardingCallBooking && (
			            <AHref href={"https://meetings.hubspot.com/returngo/onboarding-session"} target="_blank">
				            <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.UNDER_LINE}>
					            {"Schedule an onboarding call"}
				            </FontBody1>
			            </AHref>
		            )}
	            </ResolveCapability>
                <div>
                    <Button
                        text={getTranslation('BACK', scope)}
                        variant={BUTTON_VARIANTS.Transparent}
                        onClick={() => store.previousStep()}
                    />
                </div>
            </div>

        </div>
    );
});

export default FinalOnboardingScreen;